<template>
  <div id="app">
    <v-app>
      <v-app-bar app class="header-wrapper" dark dense flat>
        <div class="d-flex align-center fill-height ml-2">
          <v-icon small>mdi-store-marker</v-icon>
          <div v-if="restaurantInfo" class="ml-2" style="text-align: left">
            <div class="text-body-2">{{ restaurantInfo.name }}</div>
          </div>
        </div>

        <v-spacer></v-spacer>
        <LangSwitch/>
      </v-app-bar>
      <v-main app>
        <router-view></router-view>
      </v-main>
      <v-bottom-navigation :value="activeRoute" app color="primary" dark grow height="64">
        <v-btn value="/index" @click="goto('/index')">
          <span class="text-capitalize">{{ $t('Home') }}</span>
          <v-icon class="mb-1">mdi-home</v-icon>
        </v-btn>
        <v-btn value="/menu" @click="goto('/menu')">
          <span class="text-capitalize">{{ $t('Menu') }}</span>
          <v-icon class="mb-1">mdi-food-fork-drink</v-icon>
        </v-btn>
        <v-btn value="/order" @click="goto('/order')">
          <span class="text-capitalize">{{ $t('Order') }}</span>
          <v-icon class="mb-1">mdi-list-box</v-icon>
        </v-btn>

        <v-btn value="/my" @click="goto('/my')">
          <span class="text-capitalize">{{ $t('My') }}</span>
          <v-icon class="mb-1">mdi-account</v-icon>
        </v-btn>
      </v-bottom-navigation>
      <v-dialog :value="showAnnouncement" persistent>
        <v-card v-if="restaurantInfo" v-dragscroll class="pa-4 py-6"
                style="max-height: calc(100vh - 400px);overflow:hidden">
          <div class="text-center text-body-1 amber--text text--lighten-4 font-weight-bold">
            {{ restaurantInfo.scanQRAnnouncementHead ? restaurantInfo.scanQRAnnouncementHead : restaurantInfo.buffetAnnouncementHead }}
          </div>
          <div class="text-body-2 mt-6" v-html="restaurantInfo.scanQRAnnouncementBody ? restaurantInfo.scanQRAnnouncementBody : restaurantInfo.buffetAnnouncementBody">
          </div>
          <div class="d-flex align-center justify-center">
            <v-btn class="mt-6" color="grey lighten-4 black--text" @click="closeShowAnnouncement">{{
                $t('Close')
              }}
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-bottom-sheet :value="showLoginPage" persistent>
        <login-page/>
      </v-bottom-sheet>
      <v-bottom-sheet :value="showComingPage" persistent>
        <v-card class="pa-4 py-6" color="grey darken-3" tile>
          <div class="text-h6">
            {{ $t('FeatureNotAvailable') }}
          </div>
          <div class="text-body-1 mt-4">
            {{ $t('StayTuned') }}!
          </div>
          <v-btn color="grey lighten-4 black--text mt-4" @click="closeComingPage">
            {{ $t('Close') }}
          </v-btn>
        </v-card>
      </v-bottom-sheet>
      <v-bottom-sheet :value="showAGB" fullscreen scrollable>
        <v-card>
          <div class="pa-6 text-body-2 pb-16" style="white-space: pre-line;overflow-y: scroll">
            <div class="text-h6">{{ $t('GeneralTerms') }}</div>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('GeneralTermsScope') }}</div>
            {{ $t('GeneralTermsText') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('ConclusionContract') }}</div>
            {{ $t('ConclusionContractText') }}<br>
            {{ $t('ConclusionContractText1') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('PricesTermsPayment') }}</div>
            {{ $t('PricesTermsPaymentText') }}<br>
            {{ $t('PricesTermsPaymentText1') }}<br>
            {{ $t('PricesTermsPaymentText2') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('DeliveryCollection') }}</div>
            {{ $t('DeliveryCollectionText') }}<br>
            {{ $t('DeliveryCollectionText1') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('CancellationModificationOrders') }}</div>
            {{ $t('CancellationModificationOrdersText') }}<br>
            {{ $t('CancellationModificationOrdersText1') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('WarrantyLiability') }}</div>
            {{ $t('WarrantyLiabilityText') }}<br>
            {{ $t('WarrantyLiabilityText2') }}<br>
            {{ $t('WarrantyLiabilityText3') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4"> {{ $t('DataProtection') }}</div>
            {{ $t('DataProtectionText') }}<br>
            {{ $t('DataProtectionText1') }}<br>
            {{ $t('DataProtectionText2') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('SeverabilityClause') }}</div>
            {{ $t('SeverabilityClauseText') }}<br>
            <div class="text-body-1 my-2 amber--text text--lighten-4">{{ $t('JurisdictionLaw') }}</div>
            {{ $t('JurisdictionLawText') }}<br>
            {{ $t('JurisdictionLawText1') }}<br>
            {{ $t('ChangeTermsConditions') }}<br>
            {{ $t('ChangeTermsConditionsText') }}<br>
            {{ $t('ChangeTermsConditionsText1') }}<br>

          </div>
          <v-btn color="grey lighten-4 black--text"
                 style="position: fixed;left: 0;right: 0;bottom: 16px;width: min-content;margin: auto"
                 @click="closeShowAGBPage">
            {{ $t('Close') }}
          </v-btn>
        </v-card>
      </v-bottom-sheet>

    </v-app>
  </div>
</template>
<script>

import {getCurrentInfo, getRestaurantInfo, getTableName} from '@/dataLayer/service/api'
import LangSwitch from "@/views/components/LangSwitch";
import {mapState} from "vuex";
import LoginPage from "@/views/pages/LoginPage.vue";
import {dragscroll} from 'vue-dragscroll'


export default {
  name: 'App',
  components: {
    LoginPage,
    LangSwitch,
  },
  directives: {
    dragscroll,
  },
  data: function () {
    return {
      consumeTypeStatusId: 0,
      tableName: getTableName(),
      restaurantInfo: null,
    }
  },
  computed: {
    ...mapState(['showLoginPage', 'showComingPage', 'showAGB', "showAnnouncement"]),
    activeRoute() {
      return this.$route.path
    },
  },
  methods: {
    goto(path) {
      this.$router.push(path)
    },
    closeComingPage() {
      this.$store.commit('showComingPage', false)
    },
    closeShowAGBPage() {
      this.$store.commit('changeAGB', false)
    },
    closeShowAnnouncement() {
      this.$store.commit('showAnnouncement', false)
    }
  },
  mounted() {
    const heartBeat = async () => {
      try {
        this.restaurantInfo = await getRestaurantInfo()
        this.consumeTypeStatusId = (await getCurrentInfo()).order.consumeTypeStatusId
      } catch (e) {
        console.log(e)
      }

    }
    this.$router.push('/index')
    heartBeat()
    // heartBeat()
    // setInterval(heartBeat, 10000)
  }

}
</script>

<style>

.header-wrapper div .consumeStatus {
  margin: auto !important;
}

.header-wrapper .v-toolbar__content {
  flex-wrap: wrap;
}

body {
  background: #000000;
}

.dishImage {
  border-radius: 16px;
  width: 120px;
  height: 80px;
  margin-left: 12px;
}

.dishLabel {
  flex-grow: 1;
}

.dishPrice {
  font-size: 0.9rem;
  color: #009de0;
}


.categoryChipItem {
  max-width: 180px;
  padding: 12px 12px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #707173;
  text-overflow: ellipsis;
  flex-shrink: 0;
  overflow: hidden;
}

.categoryTitle {
  font-size: 1.5rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
}

.categoryDesc {
  font-size: 0.9rem;
  color: rgba(32, 33, 37, 0.64);
  font-weight: 400;
  margin-top: 16px;
  white-space: pre-wrap;
}

.itemContainer {
  width: 100%;
  overflow: hidden;
}

.categoryContainer {
  margin: 1.5rem 16px
}

.infoButton {
  background: #ebf7fd !important;
  color: #009de0 !important;
  text-transform: capitalize;
}

.infoButton:hover {
  background: #ccebf9;
}

.listItem {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.5rem 0;
}

.contentPadding {
  padding: 16px;
}

.v-item-group.v-bottom-navigation .v-btn {
  height: 64px
}

</style>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: medium;
  user-select: none;
}

textarea {
  font-size: 10px;
}
</style>
